import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { GoogleOAuthProvider } from '@react-oauth/google';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <GoogleOAuthProvider clientId= "84573934466-9scikfsfena30k19g0q2mi23jjkvdffp.apps.googleusercontent.com" >
      <App />
    </GoogleOAuthProvider>,
  document.getElementById('root')
);

//{\* "638731279316-sb1ovm4iuhgs7sqcegah9d9pfvo0a17l.apps.googleusercontent.com"*/} Sidharth's Key
// "84573934466-9scikfsfena30k19g0q2mi23jjkvdffp.apps.googleusercontent.com" previous token
//"907560416356-afsde5r862kef9i7s27996t66g3bfjsg.apps.googleusercontent.com" token for gmail api